import vuerouter from "vue-router";
import Index from "./Vistas/Index.vue";
import Home from "./Vistas/Home";
import LoginMaster from "./Vistas/LoginMaster";
import CambiarContrasenia from "./Vistas/CambiarContrasenia.vue";
import ReestablecerContrasenia from "./Vistas/ReestablecerContrasenia.vue";
import rutasMaster from "./Areas/Master/router";
import rutasProspecto from "./Areas/Prospecto/router";

const rutasMasters = (vuerouter.RouteRecordRaw = [
  {
    name: "LoginMaster",
    component: LoginMaster,
    path: "LoginMaster"
  },
  {
    name: "ReestablecerContrasenia",
    path: "ReestablecerContrasenia",
    component: ReestablecerContrasenia
  },
  {
    name: "CambiarContrasenia",
    path: "CambiarContrasenia",
    component: CambiarContrasenia
  },
  {
    component: Index,
    path: ""
  },
  {
    name: "Home",
    component: Home,
    path: "Home",
    children: rutasMaster.concat(rutasProspecto)
  }
]);

export default rutasMasters;
